import axios from 'axios';
import bearerTokenHeader from 'components/api-authorization/bearerToken';

export interface IEppDiameter {
  eppDiameterID: number;
  name: string;
}

export const getEppDiameters = async () => {
  const config = await bearerTokenHeader();
  const response = await axios.get('api/EppDiameter', config);
  return response.data;
};
